export const getCustomerSourcingLanesState = (state) =>
    state.customerSourcingLanes

export const getCustomerSourcingLanes = (state) => {
    const {byId, allIds} = getCustomerSourcingLanesState(state)
    return allIds.map(id => byId[id]).filter(Boolean)
}

export const getCustomerSourcingLaneById = (state, id) => {
    if (!id) return null
    return getCustomerSourcingLanesState(state).byId[id] || null
}

export const getSelectedCustomerSourcingLaneId = (state) =>
    getCustomerSourcingLanesState(state).selectedId

export const getSelectedCustomerSourcingLane = (state) => {
    const customerSourcingLanesState = getCustomerSourcingLanesState(state)
    const {byId, selectedId} = customerSourcingLanesState
    return selectedId ? (byId[selectedId] || null) : null
}

export const getCustomerSourcingLanesLoading = (state) => 
    getCustomerSourcingLanesState(state).loading

export const getCustomerSourcingLanesError = (state) =>
    getCustomerSourcingLanesState(state).error

export const getLaneLoadStats = (state) => state.laneLoadStats
//TODO: get load last stats table format

export const getLaneOffers = (state) => state.laneOffers